export default __webpack_public_path__ + "static/media/Artboard 45.06927d94.png";